<template >
  <section id="terms">
    <div id="main">
      <div class="container-my-help">
        <article class="container-my-help-article">
          <h1>Terms of Use</h1>
          <div class="subtitle">
            By using our website, you are agreeing to these Terms of Use (“Terms”). If you do not agree, do not use our website.
            <br/><br/>
            You are responsible for ensuring the security of the personal information held on your computer, mobile or other device.
          </div>
          <div class="subtitle-box">
            <p class="num">Kam Lung Motors Limited (“Audi Hong Kong”) takes care in compiling the contents of the pages on this website and makes sure that they are updated on a regular basis. However, the information provided on this website is non-binding general information, meant for reference only. It cannot replace detailed individual advice to help the prospective buyer to make his decision. The technical features and equipment of the vehicles described are only examples. Such features and equipment can vary especially depending on the country where they are sold. They are subject to alterations at any time. You will get binding up-to-date specifications on the features, equipments or characteristics of our vehicles exclusively from your authorized dealer or importer. Whilst (“Audi Hong Kong”) endeavours to ensure the accuracy of the information on this website, no express or implied warranty is given by Audi Hong Kong as to the accuracy or completeness of the information. Audi Hong Kong does not guarantee that the information on this website can be accessed without disturbance at any time.</p>
            <p class="num">When we refer to or provide links to the websites of third parties, Audi Hong Kong does not take any responsibility for the contents of the linked website. We have no control over nor do we endorse, recommend or approve of the contents of the third party’s website. Audi Hong Kong accepts no responsibility for the content of any site to which a hypertext link from this site exists and shall not be liable to you or anyone else for any loss or damage arising from or related to its use. You maintain full responsibility and risk for your dealings with third parties and your use of third party websites, applications, content, products or services.</p>
            <p class="num">Audi Hong Kong shall not be liable to you or anyone else for any damages (including, without limitation, damages for loss of business or loss of profits) arising in contract, tort or otherwise from the use of or inability to use this website, or any material contained in it, or from any action or decision taken as a result of using this site or any material found on this website. Audi Hong Kong shall not accept any responsibility for any loss or damage arising from the information, or reproduction or re-dissemination of the information, within this website. The above exclusions and limitations apply to the fullest extent permitted by law.</p>
            <p class="num">We may make changes to these Terms from time to time and shall post the amended Terms on our website. By continuing to access or use our website, you confirm that agree to the amended Terms.</p>
            <p class="num">The use of this website and these Terms herein shall be are governed and construed in accordance with the laws of the Hong Kong Special Administrative Region, People’s Republic of China (“Hong Kong”). You consent to the exclusive jurisdiction of the courts of Hong Kong in connection with any legal action that may arise in relation to your use of our website and/or these Terms of Use, and Audi Hong Kong reserves the right to bring proceedings against you for breach of these Terms of Use in your country of residence or any other relevant country.</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TermsOfUse",
  data() {
    return {};
  },
  components: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
  #terms {
    counter-reset: num;
    h3,.subtitle {
      margin-bottom: 18px;
    }
    // h3 {
    //   font-family: 'AudiTypeExtendedBold';
    //   font-size: 22px;
    // }

    .subtitle {    
      font-size: 13px;
      line-height: 20px;
    }

    .subtitle-box {
      margin-bottom: 42px;
      padding-left: 4%;
      padding-right: 4%;
      font-size: 17px;
      line-height: 25px;
      p {
        margin-bottom: 40px;
      }
    }

    @media (max-width: 1439px) and (min-width: 1024px) {
        .subtitle-box {
            margin-bottom: 60px;
        }
    }

    .num {
      counter-increment: num;
      display: table;
      &:before {
        // counter-increment: num;
        content: counter(num) ".";
        display: table-cell;
        padding-right: 10px;
        font-weight: 600;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/help/TermsOfUse.vue